import { SpecialBook } from "../../../../src/adhoc/blog/all-wrapped.js";
import * as React from 'react';
export default {
  SpecialBook,
  React
};